import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from "@mui/material/Card";
import {alpha, useTheme} from '@mui/material/styles';
import { Tooltip, IconButton } from '@mui/material';

import {fShortenNumber} from '../../utils/format-number';

import {bgGradient} from '../../theme/css';
import Iconify from '../../components/iconify';
import ClickableTooltip from '../../components/tooltip/clickable-tooltip';

// ----------------------------------------------------------------------

export default function AnalyticsWidgetSummary({
                                                 title,
                                                 total,
                                                 icon,
                                                 funct,
                                                 color,
                                                 sx,
                                                 tooltipText,
                                                 ...other
                                               }) {
  const theme = useTheme();

  return (
    <Card sx={{width: '100%', position: 'relative'}}>
      {tooltipText && (
        <ClickableTooltip title={tooltipText} arrow>
            <IconButton
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
              }}
            >
                <Iconify icon="mdi:information-outline" width={30} height={30} color={theme.palette.text.secondary} />
            </IconButton>
        </ClickableTooltip>
      )}

      <Stack
        alignItems="center"
        sx={{
          ...(color && bgGradient({
            direction: '135deg',
            startColor: alpha(theme.palette[color].light, 0.2),
            endColor: alpha(theme.palette[color].main, 0.2),
          })),
          py: 2,
          borderRadius: 2,
          textAlign: 'center',
          color: `${color}.darker`,
          backgroundColor: 'common.white',
          margin: 2,
          maxHeight: 200,
          ...sx,
        }}
        {...other}
      >
        {icon && <Box sx={{width: 64, height: 64, mb: 1}}>{icon}</Box>}

        <Typography variant="h3">{funct ? funct(total) : fShortenNumber(total)}</Typography>

        <Typography variant="subtitle2" sx={{opacity: 0.64}}>
          {title}
        </Typography>
      </Stack>
    </Card>
  );
}

AnalyticsWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
  title: PropTypes.string,
  total: PropTypes.number,
  funct: PropTypes.func,
  tooltipText: PropTypes.string,
};
